import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ActivatedRoute} from "@angular/router";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {TerminalsImportRow} from "../../../../shared/interface/terminals-import-row";
import {TerminalsImportRowService} from "../../../../shared/services/terminals-import-row.service";

@Component({
  selector: 'app-terminals-imports-row-details',
  templateUrl: './terminals-imports-row-details.component.html',
  styleUrls: ['./terminals-imports-row-details.component.scss']
})
export class TerminalsImportsRowDetailsComponent  implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  terminalsImportRowId: string;
  termianlsImportRowObject?: TerminalsImportRow;
  terminalsImportRow: ReplaySubject<TerminalsImportRow> = new ReplaySubject<TerminalsImportRow>(1);
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private terminalsImportRowService: TerminalsImportRowService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params

      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.terminalsImportRowId = params.id;
        this.loadReceivablesImportsRow();
      });

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadReceivablesImportsRow(): void {
    this.terminalsImportRowService.get(this.terminalsImportRowId).subscribe((terminalsImportRow: TerminalsImportRow) => {
      this.terminalsImportRow.next(terminalsImportRow);
      this.termianlsImportRowObject = terminalsImportRow;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
